import LecturePageRouter from '../components/lecture-page-routes';

export default class LecturePageReactController {
  /* @ngInject */
  constructor(
    $scope,
    $stateParams,
    ReportsManager,
    DiscussionsManager,
    CurrentCourseManager,
    PusherManager,
    TimedQuizzesManager,
    ReactLecturePageContext,
    humps,
  ) {
    const courseId = CurrentCourseManager.course.id;
    ReportsManager.getApprovalExercises(true);
    DiscussionsManager.initialize({ context: 'lecture', catalogId: $stateParams.catalogId });
    DiscussionsManager.initializePusherEvents(courseId);
    DiscussionsManager.initializeMentions();

    /**
     * This pusher is handling the multiple sessions in timed quiz when starting
     * a quiz. For more Info: https://novoed.atlassian.net/browse/NOV-53292.
     */
    PusherManager.currentUserChannel().bind('timed_quiz_new_window', multipleSessionsHandler);

    $scope.LecturePageRouter = LecturePageRouter;

    $scope.$on('$destroy', () => {
      DiscussionsManager.unsubscribeFromPusherEvents(courseId);
      PusherManager.currentUserChannel().unbind('timed_quiz_new_window');

      DiscussionsManager.resetSearchParams();
    });

    function multipleSessionsHandler(pusherData) {
      humps.camelizeKeys(pusherData);

      if (
        pusherData.lecturePageId === $stateParams.lecturePageId
        && pusherData.action === 'activate_window'
        && pusherData.windowId !== TimedQuizzesManager?.currentQuiz?.windowId
      ) {
        ReactLecturePageContext.updateLecturePage();
      }
    }
  }
}
